module.exports = __webpack_public_path__ + "img/tpc-19.506fdd5c.webp";